<dcr-select
  menu-positioning="fixed"
  label="Alle klassen"
  class="[ w-2xs ]"
  multiple
  [value]="store.selectedKeys()"
  [displayText]="store.selectedAssigneeNames()"
  [attr.stay-open-on-outside-click]="store.isStudentDialogOpen() ? '' : null"
  clearable
  (change)="onSelectionChange($event)"
  data-cy="assignee-filter"
>
  <span class="[ block p-xs ]">Klassen</span>
  @for (classGroup of store.classGroups(); track classGroup.id) {
    <dcr-select-option [value]="'c_' + classGroup.id" [label]="classGroup.name"></dcr-select-option>
  }
  @if (store.classGroups().length < 1) {
    <p class="[ body-small p-xs on-surface-variant ]">Geen klassen gevonden</p>
  }
  <dcr-divider></dcr-divider>
  <span class="[ block p-xs ]">Groepen</span>
  @for (group of store.groups(); track group.id) {
    <dcr-select-option [value]="'g_' + group.id" [label]="group.name"></dcr-select-option>
  }

  @if (store.groups().length < 1) {
    <p class="[ body-small p-xs on-surface-variant ]">Geen groepen gevonden</p>
  }

  @for (student of store.students(); track student.id) {
    @if (store.selectedStudentIds()[student.id]) {
      <dcr-select-option class="[ hidden ]" [value]="'s_' + student.id" [label]="student.label"></dcr-select-option>
    }
  }
  <dcr-divider></dcr-divider>
  <div class="flex justify-between items-center p-ie-s">
    <div class="[ flex flex-column gap-xxs p-xs cursor-pointer ]" (click)="onOpenStudentDialog()">
      <span class="[ body-small ]">Aangepast...</span>
      <span class="[ body-small on-surface-variant ]">Kies individuele leerlingen</span>
    </div>
    <span class="[ body-small on-surface-variant ]">{{ studentAmount() }}</span>
  </div>
</dcr-select>

@if (store.isStudentDialogOpen()) {
  <dcr-dialog [attr.open]="store.isStudentDialogOpen()" type="custom" headline="Kies leerlingen">
    <dcr-text-field
      class="[ w-full m-b-xs ]"
      type="search"
      placeholder="Zoeken"
      (input)="onSearchTermUpdated($event.target.value)"
    ></dcr-text-field>

    <div class="[ w-full max-h-s overflow-auto flex flex-column ]">
      @if (store.studentsGroupedByClassGroup().length === 0 && store.studentsGroupedByGroup().length === 0) {
        <p class="[ body-medium p-m ]">Geen leerlingen gevonden</p>
      }

      @if (store.studentsGroupedByClassGroup().length > 0) {
        <h2 class="[ title-medium m-b-s ]">Klassen</h2>
        @for (classGroup of store.studentsGroupedByClassGroup(); track classGroup.classGroupId) {
          <div class="[ m-b-l ]">
            <h3 class="[ title-small m-b-xs ]">{{ classGroup.classGroupName }}</h3>
            @if (classGroup.students.length === 0) {
              <p class="[ body-small p-xs on-surface-variant ]">Geen leerlingen in deze klas</p>
            }
            <div class="[ flex flex-column gap-xs ]">
              @for (student of classGroup.students; track student.id) {
                <div class="[ flex items-center gap-xs ]">
                  <dcr-checkbox
                    [checked]="store.selectedStudentIds()[student.id] || false"
                    (change)="onStudentToggle(student.id, $event.target.checked)"
                  ></dcr-checkbox>
                  <dcr-avatar
                    [firstName]="student.firstName"
                    [lastName]="student.name"
                    [imageUrl]="student.avatar"
                    [showInitials]="!student.avatar"
                    readonly
                    content-direction="ltr"
                  ></dcr-avatar>
                  <span class="[ body-medium ]">{{ student.label }}</span>
                </div>
              }
            </div>
          </div>
        }
      }

      @if (store.studentsGroupedByGroup().length > 0) {
        <h2 class="[ title-medium m-b-s m-t-l ]">Groepen</h2>
        @for (group of store.studentsGroupedByGroup(); track group.groupId) {
          <div class="[ m-b-l ]">
            <h3 class="[ title-small m-b-xs ]">{{ group.groupName }}</h3>
            @if (group.students.length === 0) {
              <p class="[ body-small p-xs on-surface-variant ]">Geen leerlingen in deze groep</p>
            }
            <div class="[ flex flex-column gap-xs ]">
              @for (student of group.students; track student.id) {
                <div class="[ flex items-center gap-xs ]">
                  <dcr-checkbox
                    [checked]="store.selectedStudentIds()[student.id] || false"
                    (change)="onStudentToggle(student.id, $event.target.checked)"
                  ></dcr-checkbox>
                  <dcr-avatar
                    class="[ cursor-pointer ]"
                    [firstName]="student.firstName"
                    [lastName]="student.name"
                    [imageUrl]="student.avatar"
                    [showMenu]="true"
                    [showInitials]="!student.avatar"
                    data-cy="btn-header-profile"
                    content-direction="ltr"
                    id="header-profile-avatar"
                  ></dcr-avatar>

                  <span class="[ body-medium ]">{{ student.label }}</span>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>

    <div slot="actions">
      <dcr-inline-button label="Sluiten" (click)="onCloseStudentDialog()"></dcr-inline-button>
    </div>
  </dcr-dialog>
}
